import {state} from './state';
import {userApi} from './../../api';
import App from '~/core/app'
import { ICore } from '~/core/core'; // type from the future
const core = App.Core<ICore>(); // grab sister controller

export const getId = (): string => state.id.value // the only reason this is defined this way is to prevent user modification
export const syncId = async (): Promise<string> => state.id.set((await userApi.getId()).data.value).value // the only reason this is defined this way is to prevent user modification
export const getSession = async () => {

    const res = (await userApi.getSession())
    if(res.status <= 399 && res.status >= 200){
        if(res.data.value){
            state.administrativeRoles.set(res.data.value.administrativeRoles)
            state.discord.set(res.data.value.discord)
            state.imgUrl.set(res.data.value.imgUrl)
            state.name.set(res.data.value.name)
            state.squadrons.set(res.data.value.squadrons)
        }
        return res.data;
    }else{
        throw new Error('Failed to retrieve User Session.')
    }
    

    
    
    
} // the only reason this is defined this way is to prevent user modification
export const canEditEvent = async () => {
    const myId = await getId();
    const user = core.events.collection.selectors.focused.value?.controllers?.find(controller =>  controller.id === myId);
    return user!==undefined || canCreateEvent();
}
export const canCreateEvent = () => {
    core.user.state.canCreateEvent.recompute();
    return core.user.state.canCreateEvent.value;
}
export const logout = async () => {
    try{
        await userApi.logout()
        // Cookie.('connect.sid')
    }catch(err){
        console.error(err)
    }
    
}
export const canEditFocusedEvent = async () => canEditEvent()